import { connect } from "react-redux";

import {
  storePlan,
  trackDelays,
  updatePlan,
  resetLocalPlan,
} from "store/actions/planv2";

import PlanProvider from "./Component";

const mapDispatchToProps = (dispatch) => ({
  storePlan: (
    planv2,
    planId,
    blockedWeekDays,
    planType,
    chaptersPerDay,
    quantityOfDays,
    readingOrder
  ) =>
    new Promise((resolve) => {
      dispatch(
        storePlan(
          planv2,
          planId,
          blockedWeekDays,
          planType,
          chaptersPerDay,
          quantityOfDays,
          readingOrder
        )
      );
      resolve();
    }),
  updatePlan: (
    planv2,
    blockedWeekDays,
    planType,
    chaptersPerDay,
    quantityOfDays,
    readingOrder
  ) =>
    new Promise((resolve) => {
      dispatch(
        updatePlan(
          planv2,
          blockedWeekDays,
          planType,
          chaptersPerDay,
          quantityOfDays,
          readingOrder
        )
      );
      resolve();
    }),
  trackDelays: (payload) => dispatch(trackDelays(payload)),
  resetLocalPlan: () => dispatch(resetLocalPlan()),
});

const mapStateToProps = ({
  planv2: {
    planId,
    updatePlan,
    planv2,
    lastModified,
    delays,
    planType,
    blockedWeekDays,
    chaptersPerDay,
    quantityOfDays,
    trackDelays: storedTrackDelays,
    readingOrder,
  },
}) => ({
  planId,
  updatePlan,
  lastModified,
  planv2,
  delays,
  planType,
  blockedWeekDays,
  chaptersPerDay,
  quantityOfDays,
  storedTrackDelays,
  readingOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(PlanProvider);
